import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = props => (
  <div className="notfound">
    <Helmet
      title={"Not found - Obersound"}
      meta={[{ name: "description", content: "Obersound" }]}
    />

    <p>
      Page non trouvée, retourner sur{" "}
      <Link className="notfound__link" to="/">
        l'accueil
      </Link>.
    </p>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js